import React from 'react'

const PageNotFound = (props) => {
  return (
        <div className="container">
        <div className="row">
          <div className="cb-panel-white">
            <div className="col-xs-12">
              <div className="alert alert-warning cb-alert-heading" role="alert">
                <h3>Oops !! Page not found...</h3>
              </div>
            </div>
          </div>
        </div>
      </div> )
}
export default PageNotFound